import React from 'react';
import { Carousel } from 'react-bootstrap';
import { motion } from 'framer-motion';

interface VAlumno {
    Nombre: string;
    Carrera: string;
    FechaEgreso: string;
    url_foto: string;
}

interface OrgulloSlide {
    nombre: string;
    carrera: string;
    anio: string;
    nombreEmpresa: string;
    descripcion: string;
    plantilla: string;
    datosAlumno: VAlumno;
}

interface Props {
    slides: OrgulloSlide[];
}

const OrgulloUPCarousel: React.FC<Props> = ({ slides }) => {
    return (

        <Carousel
            fade
            interval={6000}
            controls={false}
            indicators={false}
            pause={false} // esto es clave
            slide={true}
            style={{height:'70%', width:'100%'}}
        >
            {slides.map((slide, idx) => (
                <Carousel.Item key={idx}>
                    <div
                        className="d-block w-100"
                        style={{
                            backgroundImage: `url(/images/${slide.plantilla})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'top center',
                            height: '70vh',
                            position: 'relative',
                            overflow: 'hidden',
                            color: '#fff',
                        }}
                    >
                        {/* Foto en el recuadro */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '5%',
                                right: '5%',
                                width: '220px',
                                height: '290px',
                                border: '2px solid white',
                                backgroundImage: slide.datosAlumno?.url_foto
                                    ? `url(https://platinum.upchiapas.edu.mx/alumnos/images/fotos2/${slide.datosAlumno.url_foto}?v=7742)`
                                    : `url(https://platinum.upchiapas.edu.mx/siu/assets/imgs/no_picture.png)`
                                ,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                borderRadius: '8px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                            }}

                        />

                        <motion.div
                            key={slide.datosAlumno.Nombre} // ✅ fuerza remount en cada slide
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1.2 }}
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'end',
                                paddingLeft: '5%',
                                paddingRight: '5%',
                                width: '100%',
                                paddingBottom: '5%',
                                color: '#fff'
                            }}
                        >

                            <motion.h2 initial={{ y: -30 }} animate={{ y: 0 }} transition={{ delay: 0.4 }}>{slide.datosAlumno.Carrera}</motion.h2>
                            <motion.h1 className="display-4 fw-bold" initial={{ x: 50 }} animate={{ x: 0 }} transition={{ delay: 0.8 }}>{slide.datosAlumno.Nombre} | {slide.datosAlumno.FechaEgreso}</motion.h1>
                            <motion.h3 initial={{ y: 30 }} animate={{ y: 0 }} transition={{ delay: 1 }}>{slide.nombreEmpresa}</motion.h3>
                            <motion.p style={{ fontSize: "xx-large" }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }}>{slide.descripcion}</motion.p>
                        </motion.div>
                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    );
};

export default OrgulloUPCarousel;
